import Exception from "@/core/exceptions/Exception";
import DefaultExceptionTypes from "@/core/exceptions/DefaultExceptionTypes";
import { CustomerKYCResponse } from "@/core/customers/entities/CustomerKYC";
import CustomerKYCRepository from "@/core/customers/repositories/CustomerKYCRepository";

export default class GetCustomerKYCUseCase {
  constructor(
    private readonly customerKYCRepository: CustomerKYCRepository
  ) {}

  /**
   * Executes the get customer KYC use case.
   *
   * @param businessKey - The business key of the customer
   * @returns A promise resolving with CustomerKYCResponse
   * @throws {Exception} If an exception occurs during execution
   */
  async execute(businessKey: string): Promise<CustomerKYCResponse> {
    if (!businessKey || businessKey.trim() === "") {
      const exception: Exception<unknown, DefaultExceptionTypes> = {
        type: DefaultExceptionTypes.BAD_REQUEST,
        message: "Business key is required",
      };
      throw exception;
    }

    try {
      return await this.customerKYCRepository.getCustomerKYC(businessKey);
    } catch (e) {
      if ((e as Exception).type) {
        throw e;
      } else {
        throw { type: DefaultExceptionTypes.UNKNOWN_ERROR, body: e };
      }
    }
  }
}

